<template>
  <div class="wrapper nav">
    <nav>
      <div class="flex gap-4 items-center">
        <router-link :to="authStore.isLoggedIn ? '/companies' : '/auth/login'" class="flex items-center">
          <w-logo height="2.5rem" data-test="logo" />
        </router-link>

        <div v-if="authStore.isLoggedIn">
          <router-link class="secondary-dark medium" to="/companies">
            <span>Dashboard</span>
          </router-link>
        </div>
      </div>

      <div class="navbar-end">
        <div class="vl"></div>
        <span v-if="authStore.profile && authStore.isAuthenticated">
          <router-link to="/profile">
            <div class="flex justify-center items-center gap-8">
              <w-avatar large :text="authStore.profile.name" />
              <span class="semi-bold name">{{ authStore.profile.name }}</span>
            </div>
          </router-link>
        </span>
      </div>
    </nav>
  </div>
</template>

<script>
  import { useAuthStore } from '@/store/auth';
  import { mapStores } from 'pinia';
  import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

  export default {
    name: 'NavBar',
    data() {
      return {
        isScrolled: false,
        faChevronDown,
      };
    },
    components: {},
    beforeMount() {
      this.isScrolled = false;
      window.addEventListener('scroll', this.handleScroll);
    },

    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
      ...mapStores(useAuthStore),
    },
    methods: {
      handleScroll() {
        this.isScrolled = window.scrollY > 20;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';
  @import '@styles/mixins';

  .wrapper {
    background-color: $white;
    max-height: fit-content;
    height: 4.5rem;
    nav {
      height: 100%;
      width: 100%;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2px 48px;

      .logo {
        height: fit-content;
        width: 3.5rem;
      }
    }
  }
  @media (max-width: 575px) {
    .wrapper {
      // /height: 3.5rem
      nav {
        padding: 2px 12px;
        .logo {
          width: 2.5rem;
        }
      }
      .name {
        display: none;
      }
    }
  }
  .navbar-end {
    display: flex;
    align-items: center;
    gap: 0.875rem;
  }
  .dropdown-menu {
    padding-top: 0.5rem;
    height: 100%;
  }
  .dropdown-trigger {
    height: 2.5rem;
  }

  .quick-actions {
    cursor: pointer;
    background-color: $neutral-black;
    color: white;
    padding: 0.5rem 1rem;
    font-size: 0.825rem;
    border-radius: 100px;
    width: fit-content;
    @include mobile {
      display: none;
    }
    .small-icon {
      padding-top: 0.25rem;
      height: 13px;
      width: fit-content;
    }
  }
  .dark-navbar {
    nav {
      background-color: $bg-light;
      border-bottom: 1px solid $input-border;
    }
  }
</style>
